(ns common.loader.db
  (:require [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(defn open-loader [effects]
  (-> effects
      (mr/update-db assoc :loader :opening)
      (mr/conj-fx [:dispatch-later [{:ms 500
                                     :dispatch [:loader/show]}]])))

(defn close-loader [effects]
  (update effects :db dissoc :loader))

(rf/reg-event-fx :loader/open
  (fn [{:keys [db]} _]
    (open-loader {:db db})))

(rf/reg-event-fx :loader/show
  (fn [{:keys [db]} _]
    ;; Ignore the event from dispatch-later if the loader has been closed
    ;; already. In theory, if we get multiple open and close quickly, a timeout
    ;; from first open could trigger after second open and loader opens sooner
    ;; than intended, but that seems so improbable that it isn't handled
    ;; right now.
    ;; Possible solution: An identifier (counter or smth) could be added to the
    ;; show event on open-loader so it is possible to check if the timeout was
    ;; triggered by the latest open event.
    (when (= :opening (:loader db))
      {:db (assoc db :loader :open)})))

(rf/reg-event-fx :loader/close
  (fn [{:keys [db]} _]
    (close-loader {:db db})))

(rf/reg-sub :loader/open?
  (fn [db _]
    (= :open (:loader db))))

(comment
  (rf/dispatch [:loader/open])
  (rf/dispatch [:loader/close]))
